import FeaturedBrandCard from "../../Shared/FeaturedBrandCard";
import firebase from "firebase/app";
import "firebase/messaging";

import React, { Component } from "react";
import HomePromoBanner from "./HomePromoBanner";
import Footer from "../Footer";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import ContentLoader from "react-content-loader";
import Ink from "react-ink";

import { getPromoSlides } from "../../../services/promoSlider/actions";
import { getSingleLanguageData } from "../../../services/languages/actions";
import { getUserNotifications } from "../../../services/alert/actions";
import { resetInfo, resetItems } from "../../../services/items/actions";
import { getImageUrl } from "../../../helpers/imageUrl";
import { getRestaurantCanonical } from "../../../helpers/canonicalUrl";
import { AppMode } from "../../../constants";
import { setAppMode, initializeAppMode } from "../../../services/settings/actions";
import {
  getDeliveryRestaurants,
  getSelfpickupRestaurants,
} from "../../../services/restaurant/actions";
import { getHomeCategories } from "../../../services/categories/actions";
import { getBrands } from "../../../services/brands/actions";
import { sortRestaurantsByDeliveryTime } from "../../../helpers/storeDeliveryFilter";
import DelayLink from "../../helpers/delayLink";

import { isDesktopViewport } from "../../../helpers/viewport.js";
import { settleEnteredWrapper } from "../../../helpers/pageTransitionScroll";
import { formatStoreRating } from "../../../helpers/storeRating";
import { CATEGORY_PLACEHOLDER } from "../../../helpers/categoryPlaceholder";
const FA = {
  zIcon:       "/assets/img/home/z-icon.png",
  magnify:     "/assets/img/home/magnify.svg",
  mapPin:      "/assets/img/home/map-pin.svg",
  star:        "/assets/img/home/star.svg",
  lightning:   "/assets/img/home/lightning.png",
  pinSmall:    "/assets/img/home/pin-small.png",
  vSep:        "/assets/img/home/v-sep.svg",
  navHome:     "/assets/img/home/nav-home.svg",
  navCat:      "/assets/img/home/nav-cat.svg",
  navCart:     "/assets/img/home/nav-cart.svg",
  navWish:     "/assets/img/home/nav-wish.svg",
  navMe:       "/assets/img/home/nav-me.svg",
  featuredBadge: "/assets/img/home/brand-featured-badge.png",
  shareIcon:   "/assets/img/buttons/share-outline.svg",
  glassBtnTex: "/assets/img/buttons/glass-btn-texture-1.png",
};

// ── Mock data for fields not yet in the API ──────────────────────────────────
const MOCK_TAGS   = ["Western · Casual", "Sports · Active", "Outdoor · Trek", "Formal · Office", "Casual · Daily"];
// Figma "Home - Rush" (321:131) — frame linear gradient stops (approx. 166.68deg in CSS)
const HOME_RUSH_GRADIENT =
  // Keep the top rush tone consistent while scrolling (no pink stop).
  "linear-gradient(166.68deg, #0d1039 0%, #030520 61.2%, #02041e 100%)";

const HOME_RUSH_BG = {
  backgroundImage: HOME_RUSH_GRADIENT,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top center",
  backgroundSize: "100% 100%",
  // Avoid background-attachment:fixed — broken on iOS WKWebView and causes white gaps while scrolling.
  backgroundColor: "#02041e",
};

/** Fixed header — survives page-transition wrappers where sticky can fail after route changes. */
const HOME_HEADER_OFFSET = "calc(100px + env(safe-area-inset-top, 0px))";

const HOME_FIXED_HEADER = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 100,
  backgroundColor: "#0d1039",
  // backgroundImage: HOME_RUSH_GRADIENT,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top center",
  backgroundSize: "100% 100%",
  paddingTop: "env(safe-area-inset-top, 0px)",
  paddingBottom: "4px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
  isolation: "isolate",
};

const resetHomeScrollContainer = () => {
  const wrappers = document.querySelectorAll(".page-transition-wrapper");
  const live = Array.from(wrappers).find(
    (node) => node.className && !String(node.className).includes("-exit")
  );
  settleEnteredWrapper(live || null);
};

// ── Shared inline styles ─────────────────────────────────────────────────────
const S = {
  font: "'Montserrat', sans-serif",
  page: {
    minHeight: "100dvh",
    ...HOME_RUSH_BG,
    paddingBottom: "calc(var(--app-footer-total-height, 56px) + 8px)",
    fontFamily: "'Montserrat', sans-serif",
  },
  sectionTitle: {
    fontSize: "13px", fontWeight: 600, color: "#e2e2e2",
    fontFamily: "'Montserrat', sans-serif",
  },
  seeAll: {
    fontSize: "12px", fontWeight: 600, color: "#e74798",
    fontFamily: "'Montserrat', sans-serif",
  },
};

class Home extends Component {
  constructor(props) {
    super(props);
    if (props.history.action === "POP") {
      const savedPos = sessionStorage.getItem("scrollPos_/home");
      if (savedPos) window.scrollTo(0, parseInt(savedPos, 10));
    }
    this.state = {
      selectedMode: props.appMode || AppMode.SPRINT,
      prevScrollPos: window.pageYOffset,
      visible: true,
      currentAddress: null,
      animatingToMode: null,
      // "Stores near you" is nearest-first by default (server order); this
      // just re-sorts the already-fetched list, it doesn't refetch.
      sortByFastestDelivery: false,
    };
  }

  // ── Helpers ─────────────────────────────────────────────────────────────────
  loadCurrentAddress = () => {
    let addr = null;
    const raw = localStorage.getItem("userSetAddress");
    if (raw) {
      try {
        const p = JSON.parse(raw);
        if (p && p.address) addr = p;
      } catch (e) { /* ignore */ }
    }
    if (!addr && this.props.user && this.props.user.data && this.props.user.data.default_address)
      addr = this.props.user.data.default_address;
    return addr;
  };

  handleToggle = (mode) => {
    const target = mode === "Quick Commerce" ? AppMode.SPRINT : AppMode.RELAY;
    if (target === AppMode.RELAY) {
      this.showRushComingSoon();
      return;
    }
    if (this.props.appMode === target) return;
    this.setState({ animatingToMode: target });
    setTimeout(() => {
      if (target === AppMode.RELAY) {
        this.props.setAppMode(AppMode.RELAY);
        this.props.history.push("/relax", {
          skipPageTransition: true,
        });
      } else {
        this.props.history.replace(this.props.history.location.pathname, { modeSwitch: true });
        this.props.setAppMode(target);
      }
    }, 350);
  };

  showRushComingSoon = () => {
    this.setState({ rushHint: true });
    clearTimeout(this.rushHintTimer);
    this.rushHintTimer = setTimeout(() => this.setState({ rushHint: false }), 2200);
  };

  handleSearch = () => this.props.history.push("/explore");

  handleShareStore = (e, restaurant) => {
    e.preventDefault();
    e.stopPropagation();

    const title = restaurant.name || "Check out this store";
    const url = getRestaurantCanonical(restaurant.slug);

    if (navigator.share) {
      navigator.share({ title, text: title, url }).catch(() => {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).catch(() => {});
    }
  };

  handleSprintCategoryClick = (category) => {
    localStorage.setItem("categorySelectOptions", JSON.stringify([{ value: category.id, label: category.name }]));
    localStorage.setItem("filterType", "item_category");
    this.props.history.push("/categories/stores");
  };

  handleScroll = () => {
    const { prevScrollPos } = this.state;
    const cur = window.pageYOffset;
    this.setState({ prevScrollPos: cur, visible: prevScrollPos > cur || cur < 10 });
  };

  // ── Lifecycle ────────────────────────────────────────────────────────────────
  async componentDidMount() {
    resetHomeScrollContainer();
    document.documentElement.style.backgroundColor = "#02041e";
    document.body.style.backgroundColor = "#02041e";
    // Only wipe cached stores when navigating here via a full "fresh" push.
    // Footer-tab clicks use { state: { skipPageTransition: true } } so the
    // previously loaded store list stays visible during the background refresh,
    // keeping the page tall enough to scroll immediately.
    const isFooterNav =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.skipPageTransition;

    if (this.props.history.action !== "POP" && !isFooterNav) {
      this.props.resetItems();
      this.props.resetInfo();
    }
    this.setState({ selectedMode: this.props.appMode });
    window.addEventListener("scroll", this.handleScroll);
    // After categories → home transition, ensure wrapper is not still position:fixed
    this._scrollContainerFixTimer = setTimeout(resetHomeScrollContainer, 350);

    const addr = this.loadCurrentAddress();
    if (addr) this.setState({ currentAddress: addr });

    this.storageCheckInterval = setInterval(() => {
      const newAddr = this.loadCurrentAddress();
      const cur = JSON.stringify(this.state.currentAddress);
      if (JSON.stringify(newAddr) !== cur) this.setState({ currentAddress: newAddr });
    }, 500);

    // Fetch categories
    this.props.getHomeCategories();

    // Featured brands strip (server-limited to 4)
    this.props.getBrands({ featured: true, limit: 4 });

    // Fetch stores
    const raw = localStorage.getItem("userSetAddress");
    if (raw) {
      const userSetAddress = JSON.parse(raw);
      const lat = userSetAddress.lat;
      const lng = userSetAddress.lng;
      const token = this.props.user && this.props.user.data ? this.props.user.data.auth_token : null;
      const uid   = this.props.user && this.props.user.data ? this.props.user.data.id : null;
      try {
        localStorage.setItem("userPreferredSelection", "DELIVERY");
        this.props.getDeliveryRestaurants(lat, lng, token, uid);
      } catch (e) { /* ignore */ }

      if (localStorage.getItem("showPromoSlider") === "true" && this.props.user && this.props.user.data) {
        this.props.getPromoSlides(lat, lng, token, uid);
      }
      if (this.props.user && this.props.user.success) {
        this.props.getUserNotifications(uid, token);
      }
    }

  }

  componentWillReceiveProps(nextProps) {
    if (this.props.languages !== nextProps.languages) {
      const pref = localStorage.getItem("userPreferedLanguage");
      if (pref) {
        this.props.getSingleLanguageData(pref);
      } else if (nextProps.languages && nextProps.languages.length) {
        const def = nextProps.languages.find((l) => l.is_default === 1);
        if (def) this.props.getSingleLanguageData(def.id);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.setState({ currentAddress: this.loadCurrentAddress() });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.rushHintTimer);
    window.removeEventListener("scroll", this.handleScroll);
    if (this.storageCheckInterval) clearInterval(this.storageCheckInterval);
    if (this._scrollContainerFixTimer) clearTimeout(this._scrollContainerFixTimer);
  }

  // ── Sub-renders ──────────────────────────────────────────────────────────────

  renderStoreSkeleton() {
    const skeletonWidth = Math.max(
      280,
      Math.min(typeof window !== "undefined" ? window.innerWidth - 32 : 343, 375)
    );

    return [0, 1, 2].map((i) => (
      <ContentLoader
        key={i}
        height={131}
        width={skeletonWidth}
        speed={1.2}
        backgroundColor="#1a1e45"
        foregroundColor="#2a2e5a"
        style={{
          display: "block",
          margin: "0 16px 12px",
          borderRadius: "14px",
          width: "calc(100% - 32px)",
          maxWidth: "100%",
        }}
      >
        <rect x="0" y="0" rx="14" ry="14" width={skeletonWidth} height="131" />
      </ContentLoader>
    ));
  }

  renderCatSkeleton() {
    return (
      <div style={{ display: "flex", gap: "16px", padding: "0 16px 16px", overflowX: "auto", touchAction: "pan-x pan-y" }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} style={{ flexShrink: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
            <div style={{ width: "58px", height: "58px", borderRadius: "50%", background: "rgba(170,121,255,0.15)" }} />
            <div style={{ width: "40px", height: "8px", borderRadius: "4px", background: "rgba(170,121,255,0.15)" }} />
          </div>
        ))}
      </div>
    );
  }

  renderStoreCard(restaurant, index) {
    const rating      = formatStoreRating(restaurant);
    const delivTime   = restaurant.delivery_time || "15-20 mins";
    const dist        = restaurant.distance ? `${parseFloat(restaurant.distance).toFixed(1)} km` : "1.2 km";
    const tag         = MOCK_TAGS[index % MOCK_TAGS.length];
    const isInactive  = !restaurant.is_active;

    return (
      <div
        key={restaurant.id}
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <button
          type="button"
          aria-label={`Share ${restaurant.name}`}
          onClick={(e) => this.handleShareStore(e, restaurant)}
          style={{
            position: "absolute",
            top: "38px",
            right: "26px",
            zIndex: 2,
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            border: "0.5px solid #eabfff",
            background: "radial-gradient(ellipse at 30% 40%, rgba(165,239,255,0.2) 0%, rgba(110,191,244,0.05) 77%, rgba(70,144,212,0.2) 100%)",
            backdropFilter: "blur(40px)",
            WebkitBackdropFilter: "blur(40px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            flexShrink: 0,
            padding: 0,
          }}
        >
          <img src={FA.shareIcon} alt="" style={{ width: "18px", height: "18px" }} />
        </button>
        <DelayLink
          to={`../stores/${restaurant.slug}`}
          delay={200}
          style={{
            display: "block",
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
            textDecoration: "none",
          }}
          clickAction={() => {
            const sel = localStorage.getItem("userPreferredSelection");
            if (sel === "DELIVERY" && (restaurant.delivery_type === 1 || restaurant.delivery_type === 3))
              localStorage.setItem("userSelected", "DELIVERY");
          }}
        >
        <div style={{
          display: "flex",
          alignItems: "stretch",
          width: "calc(100% - 32px)",
          maxWidth: "calc(100% - 32px)",
          margin: "0 16px 12px",
          boxSizing: "border-box",
          background: "rgba(170,121,255,0.15)",
          border: "0.5px solid #bb7eff",
          borderRadius: "14px",
          overflow: "hidden",
          opacity: isInactive ? 0.6 : 1,
          position: "relative",
        }}>
          {/* Left: store image — white frame per Figma, vertically centered */}
          <div style={{
            padding: "8px 0 8px 8px",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
          }}>
            <div style={{
              padding: "3px",
              background: "#ffffff",
              borderRadius: "11px",
              flexShrink: 0,
              lineHeight: 0,
            }}>
              <img
                src={getImageUrl(restaurant.image)}
                alt={restaurant.name}
                style={{
                  width: "clamp(86px, 27vw, 118px)",
                  aspectRatio: "1 / 1",
                  height: "auto",
                  borderRadius: "9px",
                  objectFit: "cover",
                  display: "block",
                }}
                onError={(e) => { e.target.src = "/assets/img/various/shop-placeholder.jpeg"; }}
              />
            </div>
          </div>

          {/* Right: info — flex column fills card height, bottom row pinned down */}
          <div style={{
            flex: 1,
            minWidth: 0,
            padding: "8px 10px",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}>
            <div style={{ minWidth: 0 }}>
              {/* Rating – top right (share button is outside the link wrapper) */}
              {rating && (
              <div style={{
                position: "absolute",
                top: "8px",
                right: "10px",
                display: "flex",
                alignItems: "center",
                gap: "3px",
                flexShrink: 0,
              }}>
                <img src={FA.star} alt="" style={{ width: "14px", height: "14px" }} />
                <span style={{ fontWeight: 600, fontSize: "12px", color: "#fff", fontFamily: S.font }}>
                  {rating}
                </span>
              </div>
              )}

              {/* Store name */}
              <p style={{
                margin: "0 0 2px",
                fontWeight: 700,
                fontSize: "15px",
                color: "#fff",
                fontFamily: S.font,
                textTransform: "capitalize",
                paddingRight: "48px",
                lineHeight: 1.3,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}>
                {restaurant.name}
              </p>

              {/* Location */}
              {restaurant.locality && String(restaurant.locality).trim() ? (
              <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px", minWidth: 0 }}>
                <img src={FA.pinSmall} alt="" style={{ width: "9.33px", height: "13.33px", opacity: 0.85, flexShrink: 0 }} />
                <span style={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#eabfff",
                  fontFamily: S.font,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  minWidth: 0,
                  flex: 1,
                }}>
                  {String(restaurant.locality).trim()}
                </span>
              </div>
              ) : null}

              {/* Timing + distance */}
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                minWidth: 0,
                overflow: "hidden",
              }}>
                <img src={FA.lightning} alt="" style={{ width: "7px", height: "12.83px", flexShrink: 0 }} />
                <span style={{
                  fontSize: "11px",
                  fontWeight: 500,
                  color: "#eabfff",
                  fontFamily: S.font,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  minWidth: 0,
                  flexShrink: 1,
                }}>
                  {delivTime}
                </span>
                <div style={{ width: "1px", height: "9px", background: "#6b6a88", flexShrink: 0 }} />
                <span style={{
                  fontSize: "11px",
                  fontWeight: 500,
                  color: "#eabfff",
                  fontFamily: S.font,
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}>
                  {dist}
                </span>
              </div>
            </div>

            {/* Bottom row: tag + Try & Buy */}
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "8px",
              minWidth: 0,
              marginTop: "6px",
            }}>
              <div style={{
                background: "#2d2d5d",
                border: "0.5px solid #8ebbcc",
                borderRadius: "4px",
                padding: "2px 8px",
                minWidth: 0,
                flex: 1,
                overflow: "hidden",
              }}>
                <span style={{
                  fontSize: "10px",
                  fontWeight: 500,
                  color: "#ccbdfe",
                  fontFamily: S.font,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                }}>
                  {tag}
                </span>
              </div>

              <div style={{
                background: "#b0055a",
                border: "0.5px solid #ee499b",
                borderRadius: "18px",
                padding: "3px 12px",
                flexShrink: 0,
              }}>
                <span style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#fff",
                  fontFamily: S.font,
                  whiteSpace: "nowrap",
                }}>
                  Try &amp; Buy
                </span>
              </div>
            </div>
          </div>

          <Ink duration="500" hasTouch={false} />
        </div>
        </DelayLink>
      </div>
    );
  }

  // ── Main render ──────────────────────────────────────────────────────────────
  render() {
    if (isDesktopViewport()) return <Redirect to="/" />;

    const raw = localStorage.getItem("userSetAddress");
    if (!raw) return <Redirect to="/" />;
    const userSetAddress = JSON.parse(raw);
    if (Object.keys(userSetAddress).length === 0) return <Redirect to="/" />;

    const { user, promo_slides, restaurants, homeCategories, featuredBrands, featuredBrandsLoading } = this.props;
    const { animatingToMode, currentAddress } = this.state;

    const addressText = currentAddress ? (currentAddress.address || "") : "";
    const shortAddr   = addressText.length > 35 ? addressText.slice(0, 35) + "…" : addressText;
    const isSprintMode = (animatingToMode || this.props.appMode) === AppMode.SPRINT;

    const cats        = Array.isArray(homeCategories) ? homeCategories.slice(0, 5) : [];
    const baseStoreList = Array.isArray(restaurants) ? restaurants : [];
    const storeList   = this.state.sortByFastestDelivery
      ? sortRestaurantsByDeliveryTime(baseStoreList)
      : baseStoreList;
    const catsLoading = this.props.homeCategoriesLoading;
    const storesLoading = storeList.length === 0;

    return (
      <div style={S.page}>

        {/* ── FIXED HEADER (spacer below reserves layout height) ─────────────── */}
        <header className="home-fixed-header" style={HOME_FIXED_HEADER}>
          {/* Row 1: logo + search + actions */}
          <div style={{ display:"flex", alignItems:"center", gap:"8px", padding:"12px 16px 4px" }}>
            <img src={FA.zIcon} alt="logo"
              style={{ width:"30px", height:"40px", objectFit:"contain", flexShrink:0 }} />

            <div onClick={this.handleSearch}
              style={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                height: "44px",
                borderRadius: "129px",
                padding: "0 14px",
                boxSizing: "border-box",
                background: "rgba(255,255,255,0.10)",
                backdropFilter: "blur(40px)",
                WebkitBackdropFilter: "blur(40px)",
                border: "1px solid rgba(255,255,255,0.35)",
                boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
                cursor:"pointer",
              }}
            >
              <img src={FA.magnify} alt="search" style={{ width: "20px", height: "20px", flexShrink: 0 }} />
              <span style={{ color: "#a9a2bf", fontSize: "12px", fontWeight: 500, fontFamily: S.font, flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                Search stores & products
              </span>
            </div>

          </div>

          {/* Row 2: address — typography matches Figma (Montserrat Medium 12 / #FFF / 0 letter-spacing) */}
          <div style={{ display: "flex", alignItems: "center", padding: "8px 16px 8px", minHeight: 0 }}>
            <img src={FA.mapPin} alt="" style={{ width: "18px", height: "18px", marginRight: "6px", flexShrink: 0 }} />
            <span
              style={{
                flex: 1,
                minWidth: 0,
                fontFamily: S.font,
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "normal",
                letterSpacing: 0,
                color: "#FFFFFF",
                opacity: 1,
                textAlign: "left",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {shortAddr || "Select your location"}
            </span>
            <Link
              to={user && user.success ? "/my-addresses" : "/search-location"}
              style={{ fontSize:"12px", fontWeight:600, color:"#00c026", marginLeft:"8px", whiteSpace:"nowrap", textDecoration:"none", fontFamily:S.font }}
            >
              Change
            </Link>
          </div>
        </header>
        <div aria-hidden="true" style={{ height: HOME_HEADER_OFFSET, flexShrink: 0 }} />

        {/* ── PROMO BANNER ─────────────────────────────────────────────────────── */}
        <div style={{ padding: "0 16px 16px", width: "100%", boxSizing: "border-box" }}>
          <HomePromoBanner
            slides={
              promo_slides &&
              localStorage.getItem("showPromoSlider") === "true" &&
              promo_slides.mainSlides &&
              promo_slides.mainSlides.length > 0
                ? promo_slides.mainSlides
                : []
            }
          />
        </div>

        {/* ── RUSH / RELAX TOGGLE ───────────────────────────────────────────────── */}
        <div style={{ padding:"0 17px 20px" }}>
          <div style={{
            display:"flex", height:"37px",
            background:"#271b47", border:"0.5px solid #bb7eff",
            borderRadius:"18px", overflow:"hidden", position:"relative",
          }}>
            <div style={{
              position:"absolute",
              left: isSprintMode ? 0 : "50%",
              width:"50%", height:"100%",
              background:"#b0055a", border:"0.5px solid #ee499b",
              borderRadius:"18px",
              transition:"left 0.35s ease",
            }} />
            {["Quick Commerce", "Relax"].map((m) => {
              const isActive = isSprintMode ? m === "Quick Commerce" : m === "Relax";
              return (
                <button key={m} onClick={() => this.handleToggle(m)}
                  style={{
                    flex:1, zIndex:1, position:"relative", background:"transparent", border:"none",
                    fontSize:"13px", fontWeight:600, fontFamily:S.font,
                    color: isActive ? "#fff" : "#e2e2e2", cursor:"pointer",
                  }}
                >
                  {m === "Relax" ? (
                    <span style={{ display:"inline-flex", alignItems:"center", gap:"6px", opacity:0.75 }}>
                      Relax
                      <span style={{ fontSize:"8px", fontWeight:700, letterSpacing:"0.4px", textTransform:"uppercase", padding:"2px 6px", borderRadius:"8px", background:"rgba(255,255,255,0.18)", border:"0.5px solid rgba(255,255,255,0.35)" }}>Soon</span>
                    </span>
                  ) : "Rush"}
                </button>
              );
            })}
          </div>
          {this.state.rushHint && (
            <div role="status" style={{ marginTop:"8px", textAlign:"center", fontSize:"12px", fontWeight:600, fontFamily:S.font, color:"#e9d5ff" }}>
              Relax is coming soon. Enjoy Rush for now!
            </div>
          )}
        </div>

        {/* ── CATEGORIES (5 circles) ──────────────────────────────────────────── */}
        {catsLoading ? this.renderCatSkeleton() : (
          <div style={{ display:"flex", gap:"16px", padding:"0 16px 20px", overflowX:"auto", scrollbarWidth:"none", WebkitOverflowScrolling:"touch", touchAction:"pan-x pan-y" }}>
            {cats.length > 0 ? cats.map((cat) => (
              <div key={cat.id}
                onClick={() => this.handleSprintCategoryClick(cat)}
                style={{ flexShrink:0, display:"flex", flexDirection:"column", alignItems:"center", gap:"5px", cursor:"pointer" }}
              >
                <div style={{
                  width:"58px", height:"58px", borderRadius:"50%",
                  border:"1px solid #eabfff",
                  background:"rgba(170,121,255,0.15)",
                  overflow:"hidden",
                  display:"flex", alignItems:"center", justifyContent:"center",
                }}>
                  <img
                    src={cat.placeholder || CATEGORY_PLACEHOLDER}
                    alt={cat.name}
                    style={{ width:"100%", height:"100%", objectFit:"cover" }}
                    onError={(e) => { e.target.onerror = null; e.target.src = CATEGORY_PLACEHOLDER; }}
                  />
                </div>
                <span style={{ fontSize:"9px", fontWeight:500, color:"#fff", fontFamily:S.font, textAlign:"center", maxWidth:"60px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                  {cat.name}
                </span>
              </div>
            )) : (
              /* fallback skeleton if cats empty */
              [0,1,2,3,4].map((i) => (
                <div key={i} style={{ flexShrink:0, display:"flex", flexDirection:"column", alignItems:"center", gap:"5px" }}>
                  <div style={{ width:"58px", height:"58px", borderRadius:"50%", background:"rgba(170,121,255,0.15)" }} />
                  <div style={{ width:"40px", height:"8px", borderRadius:"4px", background:"rgba(170,121,255,0.15)" }} />
                </div>
              ))
            )}
          </div>
        )}

        {/* ── FEATURED BRANDS ─────────────────────────────────────────────────── */}
        {(featuredBrandsLoading || (featuredBrands && featuredBrands.length > 0)) && (
        <div style={{ padding:"0 16px 20px" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"12px" }}>
            <span style={S.sectionTitle}>Featured Brands</span>
            <Link to="/relax/brands" style={{ ...S.seeAll, textDecoration: "none" }}>See all</Link>
          </div>
          {featuredBrandsLoading && (!featuredBrands || featuredBrands.length === 0) ? (
            <div style={{
              display:"grid",
              gridTemplateColumns:"repeat(4, minmax(0, 1fr))",
              columnGap:"12px",
              justifyItems:"center",
              width:"100%",
              maxWidth:"560px",
              margin:"0 auto",
            }}>
              {[0, 1, 2, 3].map((i) => (
                <div key={i} style={{ width:"min(72px, 100%)", display:"flex", flexDirection:"column", alignItems:"center" }}>
                  <div style={{
                    width:"100%", height:"76px", borderRadius:"8px",
                    background:"rgba(170,121,255,0.15)", border:"1px solid #eabfff",
                  }} />
                  <div style={{ marginTop:"6px", width:"48px", height:"10px", borderRadius:"4px", background:"rgba(170,121,255,0.15)" }} />
                </div>
              ))}
            </div>
          ) : (
          <div style={{
            display:"grid",
            gridTemplateColumns:"repeat(4, minmax(0, 1fr))",
            columnGap:"12px",
            justifyItems:"center",
            width:"100%",
            maxWidth:"560px",
            margin:"0 auto",
          }}>
            {(featuredBrands || []).map((brand) => (
              <FeaturedBrandCard key={brand.id || brand.brand_name || brand.name} brand={brand} />
            ))}
          </div>
          )}
        </div>
        )}

        {/* ── STORES NEAR YOU ──────────────────────────────────────────────────── */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"0 16px 12px" }}>
          <span style={S.sectionTitle}>Stores near you</span>
          <button
            type="button"
            onClick={() => this.setState((prev) => ({ sortByFastestDelivery: !prev.sortByFastestDelivery }))}
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              fontSize: "12px",
              fontWeight: 600,
              fontFamily: S.font,
              color: this.state.sortByFastestDelivery ? S.seeAll.color : "#8e92ab",
              cursor: "pointer",
            }}
          >
            Fastest delivery
          </button>
        </div>

        {storesLoading ? (
          this.renderStoreSkeleton()
        ) : storeList.length === 0 ? (
          <div style={{ textAlign:"center", padding:"32px 16px", color:"#8e92ab", fontFamily:S.font, fontSize:"13px" }}>
            No stores available nearby
          </div>
        ) : (
          <div style={{ width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
            {storeList.map((r, i) => this.renderStoreCard(r, i))}
          </div>
        )}

        {/* ── SHARED FOOTER ─────────────────────────────────────────────────── */}
        <Footer active_tab="home" />

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  promo_slides:          state.promo_slides.promo_slides,
  user:                  state.user.user,
  locations:             state.locations.locations,
  languages:             state.languages.languages,
  appMode:               state.settings.appMode,
  restaurants:           state.restaurant.restaurants,
  homeCategories:        state.categories.homeCategories,
  homeCategoriesLoading: state.categories.homeCategoriesLoading,
  featuredBrands:        state.brands ? state.brands.featuredBrands : [],
  featuredBrandsLoading: state.brands ? state.brands.featuredBrandsLoading : false,
});

export default withRouter(
  connect(mapStateToProps, {
    getPromoSlides,
    getUserNotifications,
    resetInfo,
    resetItems,
    getSingleLanguageData,
    setAppMode,
    initializeAppMode,
    getDeliveryRestaurants,
    getSelfpickupRestaurants,
    getHomeCategories,
    getBrands,
  })(Home)
);
